<svg:g
  (mouseover)="handleMouseEvent($event, 'wholeShape')"
  (mouseout)="handleMouseEvent($event, 'wholeShape')"
>
  <svg:polyline
    [attr.points]="pointsString$ | async"
    (mousedown)="handleMouseEvent($event, 'shape')"
    (dblclick)="handleMouseEvent($event, 'shape')"
    (mouseup)="handleMouseEvent($event, 'shape')"
  />
  <svg:polygon
    [attr.transform]="arrowheadTransform$ | async"
    [attr.points]="arrowheadPointString$ | async"
  />

  <ng-container *ngIf="showBorderAndSubpoints$ | async">
    <svg:g h3InteractiveBorder [points$]="points$" [shapeStore]="shapeStore" />
    <svg:g
      *ngFor="
        let subpointInfo of allSubpointInfo$ | async;
        trackBy: trackByIndex
      "
      [h3Subpoint]="subpointInfo"
      [shapeSelected]="selected"
      (mousedown)="
        handleMouseEvent($event, 'subpoint', subpointInfo.subpointIndex)
      "
      (dblclick)="handleMouseEvent($event, 'shape')"
    />
  </ng-container>
</svg:g>
